import { FormLayout } from '@piggybank/core';
import lowerFirst from 'lodash/lowerFirst';
import T from 'prop-types';
import React, { lazy, useMemo } from 'react';
import { connect } from 'react-redux';
import { retry } from 'srcAlias/global/retry';
import { navigationActions } from 'srcAlias/global/state/actions';
import { segmentConfigSelectors } from 'srcAlias/global/state/selectors';
import { useLogInfo } from 'srcAlias/utils/useLog';

export const Entry = ({
  currentPageName,
  currentSegmentConfig: { pages },
  goToNextPage,
  goToNextSegment,
  navigation,
  sessionId = '',
  ...props
}) => {
  const CurrentPageComponent = useMemo(
    () =>
      lazy(() =>
        retry(() =>
          import(
            /* webpackInclude: /pages[\/\\][a-zA-Z]+[\/\\]index\.js$/ */
            /* webpackChunkName: "segment.entry.[request]" */
            /* webpackMode: "lazy" */
            `./pages/${currentPageName}`
          )
        )
      ),
    [currentPageName]
  );

  useLogInfo({
    type: 'eligibility',
    sessionId,
  });

  const isLast = pages.length - 1 === navigation.page;
  return (
    <FormLayout>
      <div name={lowerFirst(currentPageName)}>
        <CurrentPageComponent
          {...props}
          handleNext={() => (!isLast ? goToNextPage() : goToNextSegment())}
          handleNextSegment={goToNextSegment}
          sessionId={sessionId}
        />
      </div>
    </FormLayout>
  );
};

Entry.propTypes = {
  currentSegmentConfig: T.shape({
    pages: T.arrayOf(T.oneOfType([T.string, T.object])).isRequired,
  }),
  navigation: T.shape({
    page: T.number.isRequired,
  }),
  currentPageName: T.string,
  goToNextSegment: T.func.isRequired,
  goToNextPage: T.func.isRequired,
  sessionId: T.string,
};

export default connect(
  (state, ownProps) => ({
    ...ownProps,
    navigation: state.navigation,
    currentPageName: segmentConfigSelectors.getCurrentPageName(state),
    sessionId: state.sessionId,
  }),
  (dispatch, ownProps) => ({
    goToNextPage(data = null) {
      return dispatch(
        navigationActions.nextPage({
          currentSegmentName: ownProps.currentSegmentName,
          data,
        })
      );
    },
  })
)(Entry);
